import { camel } from "./case";
import is from "./is";
const d = window?.document;
export const root = d.documentElement;
export function qs(query, finder) {
  return (finder || d).querySelector(query);
}
export function qsa(query, finder) {
  return Array.from((finder || d).querySelectorAll(query));
}
export function on(element, event, callback) {
  element.addEventListener(event, callback, false);
}
export function off(element, event, callback) {
  element.removeEventListener(event, callback, false);
}
export function triggerEvent(el, event, opt) {
  var custom = new CustomEvent(event, opt || {});

  for (let key in opt) {
    custom[key] = opt[key];
  }

  return el.dispatchEvent(custom);
}
export const css = (element, key, value) => {
  const style = element.style;
  return is.set(value) ? camel(key) in style && (style[camel(key)] = value) : is.obj(key) ? Object.keys(key).forEach(function (each) {
    camel(each) in style && (style[camel(each)] = key[each]);
  }) : parseFloat(window.getComputedStyle(element).getPropertyValue(key).replace('px', ''));
};
export const hasClass = (element, find) => (' ' + element.className + ' ').indexOf(' ' + find.trim() + ' ') !== -1;
export const addClass = (_el, _class) => {
  var clname = _el.className;

  _class.split(/\s{1,10}/).forEach(function (cl) {
    if (hasClass(_el, cl)) return;
    clname += (clname ? ' ' : '') + cl;
  });

  _el.className = clname.trim();
};
export const removeClass = (_el, _class) => {
  var clname = _el.className;

  _class.split(/\s{1,10}/).forEach(function (cl) {
    if (hasClass(_el, cl)) clname = clname.replace(new RegExp('\\s{0,20}?' + cl + '\\s{0,20}?', 'g'), '');
  });

  _el.className = clname.trim();
};
export const toggleClass = (_el, _class) => {
  var added = false,
      removed = false;

  _class.split(/\s{1,10}/).slice(0, 2).forEach(function (cl) {
    if (hasClass(_el, cl) && !removed) {
      removeClass(_el, cl);
      removed = true;
    } else if (!added) {
      addClass(_el, cl);
      added = true;
    }
  });
};